module.exports = __webpack_public_path__ + "img/omimg6.aef0fa4b.png";